module.exports = __webpack_public_path__ + "static/media/inspire.46d549e6.png";